import { render, staticRenderFns } from "./OrganizationManage.vue?vue&type=template&id=64a8e8a1&scoped=true&"
import script from "./OrganizationManage.vue?vue&type=script&lang=ts&"
export * from "./OrganizationManage.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationManage.vue?vue&type=style&index=0&id=64a8e8a1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a8e8a1",
  null
  
)

export default component.exports